  document.addEventListener("DOMContentLoaded", function () {
    var loader = document.getElementById("site-loader");
    if (!loader) return;

    if (document.documentElement.classList.contains("skip-home-loader")) return;

    setTimeout(function () {
      loader.classList.add("is-hidden");
      sessionStorage.setItem("homepage_loader_shown", "true");
    }, 300);
  });

  
  document.addEventListener("click", function(e){
  const btn = e.target.closest(".new-search-button");
  if(!btn) return;

  const drawer = document.getElementById("NewSearchDrawer");
  if(drawer){
    drawer.classList.add("open-search-drawer");
    document.body.classList.add("js-drawer-open-right");
    setTimeout(()=> document.getElementById("SchoolSearchInput")?.focus(), 50);
  }
});